module.exports = __webpack_public_path__ + "img/el-ic-identity.f0f22bbc.svg";